import _ from 'lodash';

export default class OrderConstraint {
  constructor(data) {
    this.msg = _.get(data, 'msg', '');
    this.supplier = _.get(data, 'supplier', '');
  }
}
